import { useEffect } from "react";

/** Toggled on <html> to stop the page behind full-screen Quinn from scrolling. */
const scrollLockClassName = "ai-chat-full-screen-open";

/**
 * Stops the page underneath full-screen Quinn from scrolling, so the only scrollbar on screen is
 * the chat's own message list.
 *
 * Deliberately uses its own class rather than the `portal-open` class Portal toggles for the same
 * purpose: the thumbs-down feedback Modal rendered from inside this panel is itself a Portal with
 * hideBodyScroll, and if both shared one class, closing that modal would remove the lock while
 * Quinn was still full screen. Two independent classes can overlap safely.
 */
export const useFullScreenScrollLock = (isFullScreen: boolean): void => {
  useEffect(() => {
    if (!isFullScreen) {
      return;
    }

    const html = document.documentElement;
    // Measured before the scrollbar is hidden, so it reflects the width about to be reclaimed.
    // Reserving it as a margin keeps the top bar and sidebar from jumping sideways.
    const scrollbarWidth = window.innerWidth - document.body.clientWidth;

    html.classList.add(scrollLockClassName);
    html.style.marginRight = `${scrollbarWidth}px`;

    // Also runs on unmount, which is what releases the lock when the panel is closed with the X
    // while still full screen.
    return () => {
      html.classList.remove(scrollLockClassName);
      html.style.marginRight = "";
    };
  }, [isFullScreen]);
};
